<template>
  <div>
    <v-form
      v-if="informPassword"
      ref="formPass"
    >
      <v-text-field
        prepend-icon="lock"
        label="Informe sua senha"
        type="password"
        v-model="password"
        :rules="[validatePassword]"
      />
    </v-form>
  </div>
</template>
<script>
export default {
  data: () => ({
    informPassword: false,
    password: ''
  }),
  mounted() {

  },
  methods: {
    load(informPassword) {
      this.informPassword = informPassword;
      this.password = '';
    },
    validatePassword(value) {
      var msg = '';
      if (this.informPassword) {
        if (!value) {
          msg = 'A senha deve ser informada.';
        }
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    verifyPassword() {
      let outValue = true;
      if (this.informPassword) {
        outValue = this.$refs.formPass.validate();
      }
      return outValue;
    },
    getValue() {
      let entityJson = null;
      if (this.informPassword) {
        entityJson = {};
        entityJson.password = this.password;
      }
      return entityJson;
    }
  }
};
</script>
